import { createAction, createAsyncAction } from 'typesafe-actions';
import { LoyaltyMember, LoyaltyMemberFormPayload, LoyaltyMemberLockFormPayload } from './types';

const fetchLoyaltyMembers = createAsyncAction(
  '@loyalty/members/fetch',
  '@loyalty/members/success',
  '@loyalty/members/error'
)<LoyaltyMemberFormPayload, LoyaltyMember[], unknown>();

const resetLoyaltyMembersStore = createAction('@loyalty/members/resetStore', action => () => action());

const saveLoyaltyMembersPayload = createAction(
  '@loyalty/members/savePayload',
  action => (payload: string) => action(payload)
);

const lockLoyaltyMember = createAsyncAction(
  '@loyalty/memberLock/fetch',
  '@loyalty/memberLock/success',
  '@loyalty/memberLock/error'
)<LoyaltyMemberLockFormPayload, string, unknown>();

const resetLockRequested = createAction('@loyalty/members/resetLockRequested', action => () => action());

export const loyaltyMembersActions = {
  fetchLoyaltyMembers,
  resetLoyaltyMembersStore,
  saveLoyaltyMembersPayload,
  lockLoyaltyMember,
  resetLockRequested
};
